import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useQueryWithSimpleErrorHandling } from 'hooks/apolloWrappers';
import { BALANCE_SHEET_ACCOUNT_CLASSES } from "../queries";
import { BalanceSheetDetailsListContainer } from "./BalanceSheetDetailsListContainer";
import { Card, FakeText, Accordion } from "@totalsoft/rocket-ui";
import HeaderPortal from "components/layout/HeaderPortal";
import { IconButton, useToast } from '@totalsoft/rocket-ui';
import { Tooltip } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { useApolloClient } from "@apollo/client";
import { useDispatch } from "react-redux";
import { showError } from "actions/actionCreators/snackbarActions";

export const BalanceSheetDetailsContainer = ({actions, title, currencyCode}) => {
  const params = useParams();
  const [t] = useTranslation();
  const showToast = useToast();
  const client = useApolloClient();
  const dispatch = useDispatch();
  const [accountClassesExpandedState, setAccountClassesExpandedState] = useState(null);
  
  const balanceSheetId = parseInt(params?.balanceSheetId);
  const [savingBalanceSheet, setSavingBalanceSheet] = useState(false);

  useQueryWithSimpleErrorHandling(BALANCE_SHEET_ACCOUNT_CLASSES, {
    variables: { balanceSheetId },
    onCompleted: data => {
      setAccountClassesExpandedState(
        data?.partnerBalanceSheetAccountClasses?.reduce((acc, obj) => {
          acc[obj] = false;
          return acc;
        }, {}) || {}
      );
    }
  });

  const handleExpand = useCallback(accountClass => {
    setAccountClassesExpandedState(prev => ({
      ...prev,
      [accountClass]: !prev[accountClass]
    }));
  }, []);

  const onImport = (event) => {
    const reader = new FileReader();
    let file = [];

    //check the file to be of type xlsx
    if (event.target.files[0].type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      dispatch(showError(t("BalanceSheet.IncorrectFileExtension")));
      return;
    }

    reader.onload = event => {
      if (!event) file = Object.values(new Uint8Array(reader.content));
      else file = Object.values(new Uint8Array(event.target.result));

      setSavingBalanceSheet(true);

      actions.importPartnerBalanceSheet(balanceSheetId, file, (isError) => {
        if(!isError)
        {
      showToast(t("BalanceSheet.BalanceSheetSaved"), "success", { autoClose: 3000 });
          client.cache.evict({ id: "ROOT_QUERY", fieldName: `partnerBalanceSheetAccountClasses({"balanceSheetId":${balanceSheetId}})` });
          client.cache.evict({ id: "ROOT_QUERY", fieldName: `partnerBalanceSheetIndicators({"balanceSheetId":${balanceSheetId}})` });
      Object.keys(accountClassesExpandedState).forEach(element => {
            client.cache.evict({ id: "ROOT_QUERY", fieldName: `partnerBalanceSheetDetailsByAccountClass({"accountClass":"${element}","balanceSheetId":${balanceSheetId}})` });
      });
    }
        setSavingBalanceSheet(false);
  });
  };

    if(event?.target?.files[0])
      reader.readAsArrayBuffer(event?.target?.files[0]);

  };

  return (
    <>
    <Card title={t("BalanceSheet.DetailsTitle")}>
    <HeaderPortal customTitle={title}>
        <Tooltip placement='top' title={t('BalanceSheet.ImportBalanceSheet')}>
          <div>
            <input
              style={{ display: 'none' }}
              value={''}
              type='file'
              id='selectFile'
              multiple
              accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              onChange={onImport}
              disabled={savingBalanceSheet}
            />
            <label htmlFor='selectFile'>
              <IconButton id={'importBtn'} variant='text' component='span' color='primary' disabled={savingBalanceSheet}>
                <CloudUpload />
              </IconButton>
            </label>
          </div>
        </Tooltip>
    </HeaderPortal>
      {!accountClassesExpandedState ? (
        <FakeText lines={10} />
      ) : (
        Object.keys(accountClassesExpandedState).map(accountClass => {
          return (
            <Accordion
              title={t("BalanceSheet.Details.AccountClass", { data: { accountClass: accountClass } })}
              key={accountClass}
              expanded={accountClassesExpandedState[accountClass]}
              onChange={() => handleExpand(accountClass)}
              content={
                <BalanceSheetDetailsListContainer
                  isExpanded={accountClassesExpandedState[accountClass]}
                  balanceSheetId={balanceSheetId}
                  accountClass={accountClass}
                  currencyCode={currencyCode}
                />
              }
            />
          );
        })
      )}
    </Card>
    </>
  );
};

BalanceSheetDetailsContainer.propTypes = {
  actions: PropTypes.object,
  title: PropTypes.string,
  currencyCode: PropTypes.string,
  importPaymentPlan: PropTypes.func
};

export default BalanceSheetDetailsContainer;